<div class="dialog">
  <div class="dialog-header">
    <span class="dialog-title">
      Rooms — Booking #{{ data.bookingId }}
    </span>

    <button type="button" class="close-btn" (click)="close()" aria-label="Close">
      ×
    </button>
  </div>

  <span class="dialog-subtitle">
    Family code {{ data.familyCode || '-' }}
  </span>

  @if(groups.length === 0){
  <div class="muted">No rooms assigned to this booking.</div>
  } @else {
  <div class="property-groups">
    @for(group of groups; track group.propertyName){
    <div class="property-group">
      <span class="property-name">
        {{ group.propertyName }}
      </span>

      @for(room of group.rooms; track $index){
      <div class="room-line">
        <span class="room-info">Room {{ room }}</span>
      </div>
      }
    </div>
    }
  </div>
  }
</div>
